export interface OktaUser {
    id: string;
    activated: string;
    created: string;
    lastLogin: string;
    lastUpdated: string;
    passwordChanged: string;
    credentials: {
        recovery_question: {
            question: string;
        };
    };
    profile: {
        email: string;
        firstName: string;
        lastName: string;
        login: string; // also email
        mobilePhone?: string;
        secondEmail?: string;
        userid: string; // assigned by us
        userType?: string; // assigned by us
    };
    status: OktaUserStatus;
    statusChanged: string;
}

export enum OktaUserStatus {
    staged = "STAGED",
    active = "ACTIVE",
    suspended = "SUSPENDED",
    provisioned = "PROVISIONED",
    deprovisioned = "DEPROVISIONED",
    lockedOut = "LOCKE_OUT",
}
